import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function IPerfDestination() {
    return (
        <React.Fragment>
            <p>
                It can be helpful to determine the fastest achievable transfer speed based on bandwidth throughput when
                determining potential transfer speed. Signiant recommends using <a href="https://iperf.fr">iPerf</a> to
                test the maximum bandwidth and speed achievable between a source and a destination by sending packets
                over a network.
            </p>
            <p>
                This test should be performed between the source and destination using{' '}
                <a href="./system-requirements#network-requirements">ports required for data transfer</a>, either prior
                to server installation, or by stopping Signiant services on both servers to conduct the test.
                <br />
                <br />
                Stop your Signiant services by running <code className="language-text">siginit stop</code> at the
                command line.
            </p>
            <p>
                <strong>Note</strong>: If your services cannot be stopped, tests can be performed using ports other than
                those used for file transfer. Configure your firewall as required.
            </p>
            <p>
                <a href="https://iperf.fr">Download iPerf for your operating system</a> on both the transfer source and
                destination.
            </p>
        </React.Fragment>
    );
}

IPerfDestination.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(IPerfDestination);
